import type { AdhocChannels, ConvChannels } from 'v2/types/api/conversations'
import { useMemo, useCallback } from 'react'
import { useLiveAgentsQuery, useLiveTeamsQuery } from '../queries'

export const useLiveAgentsAndTeams = (
  channel: ConvChannels | AdhocChannels,
  searchTerm: string,
) => {
  const { data: agents, refetch: refetchAgents } = useLiveAgentsQuery(channel, 60000)
  const { data: teams, refetch: refetchTeams } = useLiveTeamsQuery(channel, 60000)

  const filteredTeams = useMemo(() => {
    if (!teams) return []
    return teams
      .filter((team) => team.agent_count > 0)
      .filter((team) => team.name.toLowerCase().includes(searchTerm.toLowerCase()))
  }, [teams, searchTerm])

  const filteredAgents = useMemo(() => {
    if (!agents) return []
    return agents.filter((agent) => {
      const fullName = `${agent.account_first_name} ${agent.account_last_name}`.toLowerCase()
      const email = agent.email.toLowerCase()
      const search = searchTerm.toLowerCase()
      return agent.status_availability && (fullName.includes(search) || email.includes(search))
    })
  }, [agents, searchTerm])

  const refetch = useCallback(() => {
    refetchAgents()
    refetchTeams()
  }, [refetchAgents, refetchTeams])

  return { agents: filteredAgents, teams: filteredTeams, refetch }
}
